import { render, staticRenderFns } from "./BankCardAttachment.vue?vue&type=template&id=1d89a9a8"
import script from "./BankCardAttachment.vue?vue&type=script&lang=ts"
export * from "./BankCardAttachment.vue?vue&type=script&lang=ts"
import style0 from "./BankCardAttachment.vue?vue&type=style&index=0&id=1d89a9a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports